import {NgModule} from '@angular/core';
import {SuiteToDisplayNamePipe} from './suite-to-display-name.pipe';

@NgModule({
  declarations: [SuiteToDisplayNamePipe],
  exports: [SuiteToDisplayNamePipe],
})
export class SuiteToDisplayNameModule {}
